import React, { FunctionComponent, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useMutation } from "@apollo/client"
import { CircularProgress, Typography } from "@material-ui/core"
import { useLocation } from "react-router"
import { parse } from "query-string"

import { useNotification } from "../common/hooks/useNotification"
import { VERIFY } from "../mutations/VERIFY"
import styles from "./VerifyPage.module.scss"
import { useTokens } from "../common/hooks/useTokens"

export const VerifyPage: FunctionComponent = () => {
    const loc = useLocation()
    const hist = useHistory()
    const { notifyError } = useNotification()
    const { setAccessToken } = useTokens()

    const [verifySTA] = useMutation<{ verify: { accessToken: string } }>(VERIFY, {
        onCompleted: data => {
            setAccessToken(data.verify.accessToken)
            hist.push("/single")
        },
        onError: () => {
            localStorage.clear()
            notifyError("Unable to verify. Please login again.")
            hist.push("/login")
        }
    })

    const { token } = parse(loc.search)

    useEffect(() => {
        verifySTA({
            variables: {
                STAToken: token
            }
        })
    }, [])

    return (
        <div className={styles.VerifyPage}>
            <Typography variant="h4">Verifying...</Typography>
            <CircularProgress className={styles.VerifyPage__spinner} />
        </div>
    )
}
